/**
 * OXYLYTHE Sparpaket buybox helpers
 * - cards: force largest pack default when no ?variant=
 * - dual: sync second ATC form + keep Dawn pack on 1 Stück
 */
if (!customElements.get('oxy-sparpack')) {
  customElements.define(
    'oxy-sparpack',
    class OxySparpack extends HTMLElement {
      connectedCallback() {
        this.layout = this.dataset.layout || 'cards';
        this.onCardChange = this.onCardChange.bind(this);
        this.addEventListener('change', this.onCardChange);
        this.syncCardSelectedClass();

        if (this.layout === 'dual') {
          this.ensureSingleUnitSelected();
          this.syncDualForm();
        } else if (this.dataset.forceDefault === 'true') {
          this.forcePreferredSelection();
        }
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onCardChange);
      }

      get cards() {
        return Array.from(this.querySelectorAll('[data-oxy-sparpack-card]'));
      }

      get inputs() {
        return Array.from(this.querySelectorAll('.oxy-sparpack__input'));
      }

      onCardChange(event) {
        const input = event.target;
        if (!input || !input.classList.contains('oxy-sparpack__input')) return;
        // Dual cards must not trigger Dawn variant-selects / section refresh.
        if (this.layout === 'dual') {
          event.stopPropagation();
          this.syncDualForm();
        }
        this.syncCardSelectedClass();
      }

      syncCardSelectedClass() {
        this.cards.forEach((card) => {
          const input = card.querySelector('.oxy-sparpack__input');
          card.classList.toggle('is-selected', Boolean(input?.checked));
        });
      }

      forcePreferredSelection() {
        const preferred =
          this.querySelector('.oxy-sparpack__input[data-oxy-preferred]:not(:disabled)') ||
          this.querySelector('.oxy-sparpack__input:not(:disabled)');
        if (!preferred) return;
        if (preferred.checked) return;
        preferred.checked = true;
        preferred.dispatchEvent(new Event('change', { bubbles: true }));
        this.syncCardSelectedClass();
      }

      ensureSingleUnitSelected() {
        const sectionId = this.dataset.section;
        const variantSelects =
          (sectionId && document.getElementById(`variant-selects-${sectionId}`)) ||
          document.querySelector('variant-selects');
        if (!variantSelects) return;
        const packFieldset = variantSelects.querySelector('.oxy-sparpack-hidden-pack');
        if (!packFieldset) return;

        const inputs = Array.from(packFieldset.querySelectorAll('input[type="radio"]'));
        if (!inputs.length) return;

        const single = inputs.find((input) => {
          const value = (input.value || '').toLowerCase();
          const count = this.parsePackCount(value);
          return count === 1;
        });

        const target = single || inputs.find((input) => !input.disabled) || inputs[0];
        if (!target || target.checked) return;
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }

      parsePackCount(value) {
        const v = String(value).toLowerCase();
        if (/doppel|2er|2-pack|2 pack/.test(v)) return 2;
        if (/3er|3-pack|3 pack|dreier/.test(v)) return 3;
        if (/4er|4-pack/.test(v)) return 4;
        if (/5er|5-pack/.test(v)) return 5;
        if (/6er|6-pack/.test(v)) return 6;
        return 1;
      }

      syncDualForm() {
        const selected = this.querySelector('.oxy-sparpack__input:checked');
        const variantInput = this.querySelector('[data-oxy-sparpack-variant-id]');
        const submit = this.querySelector('.oxy-sparpack__dual-submit');
        if (!selected || !variantInput) return;

        const variantId = selected.dataset.oxyVariantId;
        const available = selected.dataset.oxyAvailable !== 'false' && !selected.disabled;
        variantInput.value = variantId;
        variantInput.disabled = !available;
        if (submit) submit.disabled = !available;
      }
    }
  );
}
